import EventV2Head from './EventV2Head';

export default EventV2Head;
